import { getToken, setToken, unsetToken } from "../../services/auth";
import { actionTypes } from './../constants/auth';

const INITIAL_PROFILE = { 
    name: null,
    email:null,
    id:null,
    group:null,
}

const INITIAL_STATE = {
    token: getToken(),
    profile: INITIAL_PROFILE,
    changes:null
}

const reducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.GET_TOKEN:
            return { ...state, token: getToken() }
        case actionTypes.SET_TOKEN:
            setToken(action.payload.token);
            return { ...state, token: getToken() }
        case actionTypes.UNSET_TOKEN:
            unsetToken();
            return { ...state, token: null };
        case actionTypes.SET_PROFILE:
            return { ...state, profile: action.payload.profile}
        case actionTypes.UNSET_PROFILE:
            return { ...state, profile: INITIAL_PROFILE}
        default:
            return state;
    }
}

export default reducers;